
// App version
export const Version = "2.5.732"



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/version.ts